import HttpClientToken from '../../services/HttpClientToken';
import HttpClientFileToken from '../../services/HttpClientFileToken';

import { BuscarLibroIndiceAlfabeticoParams, LibroIndiceAlfabeticoResponse, defaultBuscarLibroIndiceAlfabeticoResponse, DescargarInformacionParams } from '../../interfaces/libros-electronicos/LibroIndiceAlfabeticoInterface';

export const ObtenerLibroIndiceAlfabetico = ( params: BuscarLibroIndiceAlfabeticoParams ) => {

    return new Promise<LibroIndiceAlfabeticoResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if ( data ) {

            const { token } = data;

            HttpClientToken.post('/Api/LibroIndiceAlfabetico/ObtenerLibroIndiceAlfabetico', params, token)
            .then(({ data }: { data: LibroIndiceAlfabeticoResponse }) => {
                resolve(data);
            })
            .catch( () => {
                resolve({ ...defaultBuscarLibroIndiceAlfabeticoResponse });
            });

        }

    });

}

export const DescargarLibroIndiceAlfabetico = ( params: DescargarInformacionParams ) => {

    return new Promise<Blob | null>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientFileToken.post('/Api/LibroIndiceAlfabetico/DescargarInformacion', params, token)
            .then( ({ data } : { data : Blob } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( null );
            });

        }

    });

}
